import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["accept"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }

import { ref } from 'vue'
    import axios from 'axios'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'FileUploader',
  props: {
    accept: {},
    ttl: {},
    skipConfirmation: { type: Boolean },
    hideProgress: { type: Boolean }
  },
  emits: ["selected", "unselected", "progress", "uploaded", "failed"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- refs ----------------

    const fileInput = ref<HTMLInputElement | null>(null)

    // ---------------- local state ----------------

    const file = ref<File | null>(null)
    const uploadPercentage = ref(0)
    const uploading = ref(false)

    // ---------------- actions ----------------

    function handleFileSelected()
    {
        const input = fileInput.value
        if (!input?.files?.length) return

        file.value = input.files[0]
        emit('selected', file.value)

        if (props.skipConfirmation)
        {
            submitFile()
        }
    }

    function clickFileInput()
    {
        fileInput.value?.click()
    }

    function formatFileSize(size: number)
    {
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
        if (size === 0) return '0 Byte'

        const i = Math.floor(Math.log(size) / Math.log(1024))
        return Math.round(size / Math.pow(1024, i)) + ' ' + sizes[i]
    }

    function submitFile()
    {
        if (!file.value) return

        const formData = new FormData()
        formData.append('file', file.value)

        uploading.value = true

        axios.post('/blobs/v2/upload/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                ttl: props.ttl
            },
            onUploadProgress: (event) =>
            {
                if (!event.total) return

                uploadPercentage.value = Math.round((event.loaded / event.total) * 100)
                emit('progress', uploadPercentage.value)
            }
        })
            .then(response =>
            {
                emit('uploaded', response.data)
                reset()
            })
            .catch(() =>
            {
                uploading.value = false
                emit('failed')
            })
    }

    function reset()
    {
        file.value = null
        uploadPercentage.value = 0
        uploading.value = false

        if (fileInput.value)
        {
            fileInput.value.value = ''
        }
    }

    function cancelUpload()
    {
        emit('unselected')
        reset()
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!file.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("input", {
            type: "file",
            ref_key: "fileInput",
            ref: fileInput,
            class: "custom-file-input",
            onChange: handleFileSelected,
            accept: __props.accept,
            style: {"display":"none"}
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2),
          _createElementVNode("div", { onClick: clickFileInput }, [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _cache[0] || (_cache[0] = _createElementVNode("button", { class: "btn btn-outline-secondary" }, "Upload file", -1 /* CACHED */))
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (!__props.skipConfirmation && file.value && !uploading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "file", {}, () => [
            _createElementVNode("p", null, [
              _cache[1] || (_cache[1] = _createTextVNode(" Selected file: ", -1 /* CACHED */)),
              _createElementVNode("strong", null, _toDisplayString(file.value.name), 1 /* TEXT */),
              _createTextVNode(" (" + _toDisplayString(formatFileSize(file.value.size)) + "). Please confirm to proceed or cancel to select a different file. ", 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("button", {
            class: "btn btn-primary mr-1",
            onClick: submitFile
          }, "Confirm"),
          _createElementVNode("button", {
            class: "btn btn-secondary",
            onClick: cancelUpload
          }, "Cancel")
        ]))
      : _createCommentVNode("v-if", true),
    (!__props.hideProgress && file.value && uploading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("p", null, "Uploading: " + _toDisplayString(uploadPercentage.value) + "%", 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})